import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { hideDialog } from '../../../core/actions';
import ModalDialog from '../../../core/components/Modal';
import { checkErrors } from '../../../core/formValidation';
import EmployeeEditForm from '../components/EmployeeEditForm';
import { selectEmployeeInEdit } from '../reducer';
import { injectIntl } from 'react-intl';
const initialFormValues = {
  lastName: '',
  firstName: '',
  email: '',
  phoneNumber: '',
};

export class UpsertEmployeeDialog extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    closeDialog: PropTypes.func.isRequired,
    initialEmployee: PropTypes.shape({}).isRequired, // instanceOf Employee
    isNew: PropTypes.bool,
    intl: PropTypes.shape({}).isRequired,
  };

  formRef = React.createRef();
  state = { isValid: false };

  onReady = () => {
    if (this.formRef.current && this.formRef.current.submit) {
      this.formRef.current.submit();
    }
  };

  render() {
    const { closeDialog, isOpen, initialEmployee, isNew, onSubmit } = this.props;
    const enableReinitialize = !isNew;
    const submitDisabled = !this.state.isValid;
    const intl = this.props.intl;

    return (
      <ModalDialog
        title="Edit Team Member"
        onReady={this.onReady}
        isOpen={isOpen}
        close={closeDialog}
        disabled={submitDisabled}
        className="enhanced-dialog narrow padded-minimal"
      >
        <EmployeeEditForm
          ref={this.formRef}
          onSubmit={(formValues) => onSubmit({ data: { body: formValues } })}
          intl={intl}
          initialValues={initialEmployee}
          onValidityChange={(valid) => this.setState({ isValid: valid })}
        />
      </ModalDialog>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const initialEmployee = ownProps.isNew ? initialFormValues : selectEmployeeInEdit(state);
  return {
    initialEmployee,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      closeDialog: hideDialog,
    },
    dispatch
  );
};
const enhance = compose(connect(mapStateToProps, mapDispatchToProps), injectIntl);

export default enhance(UpsertEmployeeDialog);
